"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgElectricChargePoint16 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h16v16H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M9.342 13.573V3.91c0-.433-.294-.743-.728-.743H4.49c-.434 0-.728.31-.728.743v9.663m7.039 0h-8M9.34 9.86h2.275c.538 0 .975-.35.975-.781V6.306m-1.644-.57c1.075 0 1.624.339 1.647 1.015.001.22-.003.354-.003.354M10.946 5.31c1.075 0 1.624.338 1.647 1.015.001.22-.003.354-.003.354M9.342 5.248h-5.58", stroke: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "m6.883 7.33-1.6 2.543h1.158l-.22 1.619 1.6-2.544H6.661z" })] })) }))); };
exports.default = SvgElectricChargePoint16;
